import { createAction } from '@reduxjs/toolkit';

export const CLEAR_AMOUNT_REMAINING = 'ORDER/CLEAR_AMOUNT_REMAINING';

export const clearAmountRemaining = createAction(CLEAR_AMOUNT_REMAINING);
